import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { getNav } from '../navigation/index'
import { BiLogOutCircle } from 'react-icons/bi'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../store/Reducers/authReducer'
import { get_admin_dashboard_data } from '../store/Reducers/dashboardReducer'
import logo from '../assets/wlogo.png'
import { useTranslation } from 'react-i18next'
import cookies from 'js-cookie'
import { FaChevronLeft } from 'react-icons/fa'
import { socket } from '../utils/utils'

const languages = [
  {
    code: 'en',
    name: 'English',
    dir: 'ltr',
    country_code: 'en',
    image: '../../../images/language.png',
  },
  {
    code: 'kr',
    name: 'کوردی',
    dir: 'rtl',
    country_code: 'kr',
    image: '../../../images/kur.png',
  },
  {
    code: 'ar',
    name: 'عربي',
    dir: 'rtl',
    country_code: 'ar',
    image: '../../../images/kur.png',
  },
]

const Sidebar = ({ showSidebar, setShowSidebar }) => {
  const currentLanguageCode = cookies.get('i18next') || 'en'
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { role } = useSelector((state) => state.auth)
  const { requestUser } = useSelector((state) => state.dashboard)
  const navigate = useNavigate()

  const { pathname } = useLocation()
  const [allNav, setAllNav] = useState([])
  const [openSubNav, setOpenSubNav] = useState(null)

  const toggleSubNav = (id) => {
    setOpenSubNav((prevId) => (prevId === id ? null : id))
  }

  useEffect(() => {
    socket.on('registerUser', (data) => {
      dispatch(get_admin_dashboard_data())
    })
  }, [])

  useEffect(() => {
    socket.on('connect', () => {
      console.log('Connected to socket server:', socket.id)
    })

    socket.on('printHouseUpdate', (data) => {
      dispatch(get_admin_dashboard_data())
    })
    socket.on('disconnect', () => {
      console.log('Disconnected from socket server.')
    })
  }, [dispatch])

  useEffect(() => {
    dispatch(get_admin_dashboard_data())
  }, [])

  useEffect(() => {
    const navs = getNav(role)
    setAllNav(navs)
  }, [role])

  return (
    <div>
      <div
        onClick={() => setShowSidebar(false)}
        className={`fixed duration-200 ${
          !showSidebar ? 'invisible' : 'visible'
        } w-screen h-screen bg-[#8cbce780] top-0 left-0 z-10`}
      ></div>

      <div
        className={`w-[250px] fixed bg-primary z-[999] top-0 h-screen shadow-[0_0_15px_0_rgb(34_41_47_/_5%)] transition-all 
          ${
            showSidebar
              ? currentLanguage.dir === 'ltr'
                ? 'left-0'
                : 'right-0' 
              : currentLanguage.dir === 'ltr'
              ? '-left-[260px] lg:left-0'
              : '-right-[260px] lg:right-0'
          } 
       
        `}
      >
        <div className="h-[60px] flex justify-center items-center ">
          {/* <Link to="/"> */}
          <img className="w-[95px] h-auto mt-1 p-1" src={logo} alt="" />
          {/* </Link> */}
        </div>
        <div className="flex justify-center items-center border border-b-1 mt-1"></div>

        {/* <div className="px-[16px] mt-2 "> */}
        <div className="px-[16px] mt-2 h-full flex flex-col justify-between">
          <ul>
            {allNav?.map((n) => (
              <li key={n.id} className="relative">
                <Link
                  to={n.path}
                  className={`${
                    openSubNav === n.id || pathname === n.path
                      ? 'bg-secondary shadow-indigo-500/50 text-black duration-500'
                      : 'text-[#fff] text-sm font-semiBold duration-200'
                  } px-[12px] py-[9px] rounded-sm flex justify-start items-center gap-[12px] hover:pl-2 transition-all w-full mb-1`}
                  onClick={
                    n.subNav
                      ? () => {
                          toggleSubNav(n.id)
                        }
                      : undefined
                  }
                >
                  <span>{n.icon}</span>
                  <span className="relative">{t(`dashboard.${n.title}`)}</span>
                  {n.title === 'Print House' ? (
                    <span className="absolute flex justify-center items-center bg-red-500 text-white rounded-full w-[28px] h-[28px] ltr:right-0 rtl:left-0 translate-x-[50%] ">
                      {requestUser}
                    </span>
                  ) : null}
                  {n.subNav && (
                    <span className="ml-auto px-2 flex items-center">
                      {openSubNav === n.id ? (
                        <FaChevronLeft className="text-black" />
                      ) : (
                        <FaChevronLeft className="text-white" />
                      )}
                    </span>
                  )}
                </Link>

                {/* SubNav */}
                {n.subNav && openSubNav === n.id && (
                  <ul
                    className={`absolute left-full ${
                      showSidebar ? '-right-5' : '-right-1'
                    } top-0 bg-primary z-[9999] w-56 px-[6px] py-[1px] transition-transform transform -translate-x-full`}
                  >
                    {n.subNav?.map((subItem) => (
                      <li key={subItem.id}>
                        <Link
                          to={subItem.path}
                          className={`${
                            pathname === subItem.path
                              ? 'bg-[#b2ebf2] text-black duration-500'
                              : 'text-[#fff] font-bold duration-200'
                          } px-[28px] py-[8px] rounded-sm flex justify-start items-center gap-[12px] transition-all w-full mb-1`}
                          onClick={() => {
                            toggleSubNav(null)
                            setShowSidebar(false)
                          }} // Close on click
                          // onMouseLeave={() => n.subNav && toggleSubNav(null)}
                        >
                          <span className="ml-4">
                            {t(`dashboard.${subItem.title}`)}
                          </span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
            <li>
              <button
                onClick={() => dispatch(logout({ navigate, role }))}
                className="text-[#030811] text-sm font-semiBold duration-200 px-[12px] py-[9px] rounded-sm flex justify-start items-center gap-[12px] hover:pl-4 transition-all w-full mb-1"
              >
                <span className="text-white">
                  <BiLogOutCircle />
                </span>
                <span className="text-white">{t('dashboard.logout')}</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Sidebar
